module.exports = __webpack_public_path__ + "media/images/pc/items/album/album-c7025a33e2e44f5b0576730cc40b57f9.jpg";